import React from 'react';
import Loading from '../helpers/Loading';

const CKPButton = ({ label, inactive, onClick, loading, className, type }) => (
    <button
        type={type}
        onClick={inactive || loading ? null : onClick}
        className={`ckp-buttons ${className ? className : ''} ${inactive ? 'is-inactive' : ''} ${
            loading ? 'is-loading' : ''
        }`}
    >
        {loading ? <Loading color="white" size={20} /> : null}
        <span className="ckp-buttons-label">{label}</span>
    </button>
);

export default CKPButton;

// TODO-NT Use Material UI Buttons
// import Button from '@material-ui/core/Button';
// <Button onClick={inactive || loading ? null : onClick} variant="raised" color="secondary" disabled={inactive}>}*/
// {loading ? <Loading color="white" size={20} /> : label}
// </Button>



// WEBPACK FOOTER //
// ./src/components/forms/Button.js